import Well from 'components/well/well';
import React, { useMemo } from 'react';
import { useCanvasWidthPercentage } from 'redux/hooks/common';
import {
  useSelectedWellDropDetails,
  useSelectedWellDropDetailsIndex,
} from 'redux/hooks/searchnFilter';
import {
  GetUnifiedExperimentCanvasHeight,
  GetUnifiedExperimentCanvasWidth,
  history,
} from 'utils/Global';
import { useParams } from 'react-router';
import { DropDetails, WellDisplayMode } from 'components/well/constants';
import { getGridDetails } from 'components/grid/utils';
import { EGridLayout, gridColumnGap, gridRowGap } from 'components/grid/constants';
import WellProcessor from 'components/well/WellProcessor';
import { getSnfWellKey } from '../utils';
import { SNF_COMPARE_VIEW_COL_GAP_FACTOR } from '../constants';

interface Props {
  setZoomInvocker: (functionDelegate: (zoom: number) => void) => void;
  setWellRef: (wellKey: string, ref: any) => void;
}

const Drop = (props: Props) => {
  const { setZoomInvocker, setWellRef } = props;
  const canvasWidth = GetUnifiedExperimentCanvasWidth(useCanvasWidthPercentage() + 6);
  const canvasHeight = GetUnifiedExperimentCanvasHeight() - 24;
  const selectedWellDetails = useSelectedWellDropDetails();
  const selectedWellIndex = useSelectedWellDropDetailsIndex();

  const params = useParams();

  const { wellMode } = params;

  const wellDetails = useMemo(() => {
    const wellsToShow =
      wellMode === WellDisplayMode.Drop
        ? selectedWellDetails.slice(-1)
        : selectedWellDetails.slice(-4);

    const { rows, columns } = getGridDetails(wellsToShow?.length, EGridLayout.Grid);
    const size = {
      canvasWidth:
        canvasWidth / columns - columns * gridColumnGap * SNF_COMPARE_VIEW_COL_GAP_FACTOR,
      canvasHeight: canvasHeight / rows - rows * gridRowGap,
    };
    return wellsToShow.map((well) => ({
      sizeDetails: size,
      wellDetails: well,
    }));
  }, [wellMode, selectedWellDetails]);

  if (!selectedWellDetails?.length) {
    history.push(
      history.location.pathname.substring(0, history.location.pathname.lastIndexOf('/')),
    );
    return;
  }

  const wellKeyGenerator = (wellDetails: DropDetails) => {
    return getSnfWellKey(wellDetails);
  };

  return (
    <div id="index-drop-main-container" className="w-full h-[82%]">
      <WellProcessor
        displayMode={wellMode}
        gridLayout={EGridLayout.Grid}
        wells={wellDetails}
        WellRenderer={Well}
        selectedWellIndex={selectedWellIndex}
        setZoomInvocker={setZoomInvocker}
        wellKeyGenerator={wellKeyGenerator}
        setWellRef={setWellRef}
      />
    </div>
  );
};

export default Drop;
